import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="relative min-h-[80vh] flex items-center justify-center py-20">
      {/* Hintergrund-Effekte */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[20%] left-[10%] w-[600px] h-[600px] bg-brand-800/[0.03] rounded-full blur-[150px]"></div>
        <div className="absolute top-[60%] right-[5%] w-[500px] h-[500px] bg-brand-900/[0.03] rounded-full blur-[150px]"></div>
        <div className="absolute bottom-[10%] left-[30%] w-[400px] h-[400px] bg-brand-800/[0.02] rounded-full blur-[150px]"></div>
      </div>

      <div className="relative z-10 text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto"
        >
          <motion.h1
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-9xl font-serif font-light mb-4 text-white"
          >
            404
          </motion.h1>
          
          <div className="w-px h-12 bg-white/30 mx-auto mb-6"></div>
          
          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-3xl font-serif text-white mb-4"
          >
            Seite nicht gefunden
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="text-lg text-gray-300 mb-8 max-w-md mx-auto"
          >
            Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-all duration-300 font-medium shadow-lg hover:shadow-xl"
            >
              <Home className="h-5 w-5" />
              Zur Startseite
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 px-8 py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-all duration-300 font-medium backdrop-blur-sm border border-white/20"
            >
              <ArrowLeft className="h-5 w-5" />
              Zurück
            </button>
          </motion.div>
        </motion.div>
      </div>
    </div>
  )
}


















